(function(d, s, id) {
  var js,
    fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) return;
  js = d.createElement(s);
  js.id = id;
  js.src =
    "https://connect.facebook.net/en_GB/sdk.js#xfbml=1&appId=285928718280996&version=v2.9";
  fjs.parentNode.insertBefore(js, fjs);
})(document, "script", "facebook-jssdk");
// <!-- tw分享script引入 -->
window.twttr = (function(d, s, id) {
  var js,
    fjs = d.getElementsByTagName(s)[0],
    t = window.twttr || {};
  if (d.getElementById(id)) return t;
  js = d.createElement(s);
  js.id = id;
  js.src = "https://platform.twitter.com/widgets.js";
  fjs.parentNode.insertBefore(js, fjs);
  t._e = [];
  t.ready = function(f) {
    t._e.push(f);
  };
  return t;
})(document, "script", "twitter-wjs");

/**
 *
 *
 * @export
 * @param {{
 *   title: string;
 *   url: string;
 *   img?: string;
 *   desc?: string;
 *   isOrigin?: boolean;
 *   callback?: (response: any) => void;
 * }} option
 */
function shareMetaLink(option) {
  if (option.url && option.url.substr(0, 4) !== "http") {
    option.url = "https:" + option.url;
  }
  const url =
    "https://hd.c.mi.com/in/common/toshare?image=" +
    encodeURIComponent(option.img) +
    "&title=" +
    encodeURIComponent(option.title) +
    "&desc=" +
    encodeURIComponent(option.desc || "") +
    "&link=" +
    encodeURIComponent(option.url);

  return url;
}
/**
 *
 *
 * @export
 * @param {{ title: string; url: string }} option
 */
export function shareTw(option, cb) {
  let url = option.url;
  let title = option.title;

  if (url && url.substr(0, 4) !== "http") {
    url = "https:" + url;
  }
  url = shareMetaLink(option);
  const link =
    "https://twitter.com/share?url=" +
    encodeURIComponent(url) +
    "&text=" +
    encodeURIComponent(title);
  cb(link);
  window.open(
    link,
    "twitterwindow",
    "height=450, width=550, top=    " +
      (window.innerHeight / 2 - 225) +
      ", left=" +
      window.innerWidth / 2 +
      ", toolbar=0, location=0, menubar=0, directories=0, scrollbars=0"
  );
}
/**
 *
 *
 * @export
 * @param {{
 *   title: string;
 *   url: string;
 *   img?: string;
 *   desc?: string;
 *   isOrigin?: boolean;
 *   callback?: (response: any) => void;
 * }} option
 */
export function shareFb(option, cb) {
  let url = "";
  let isOrigin = option.isOrigin;
  if (option.url && option.url.substr(0, 4) !== "http") {
    option.url = "https:" + option.url;
  }
  isOrigin = option.url.indexOf("mi.com") > 0 ? isOrigin : true;
  if (isOrigin) {
    url = option.url;
  } else {
    url =
      "https://hd.c.mi.com/in/common/toshare?image=" +
      option.img +
      "&title=" +
      option.title +
      "&desc=" +
      (option.desc || "") +
      "&link=" +
      encodeURIComponent(option.url);
  }
  cb(url);
  window.FB.ui(
    {
      method: "feed",
      name: option.title,
      link: url,
    },
    function(response) {
      option.callback && option.callback(response);
    }
  );
}

/**
 *
 *
 * @export
 * @param {{
 *   url:url 跳转地址
 * }} option
 */
export function goShare(url) {
  window.open(url);
}
